import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";

import TemperatureControl from "../../../components/TemperatureControl";
import { useCoachingGeneratorStore } from "../store/coachingGeneratorStore";
import ContextOptions from "./ContextOptions";
import PromptTextField from "./PromptTextField";

interface CoachingConfigurationProps {
  attributeStatsContent: string | null;
  lensDefinitionContent: string | null;
  teamBestPracticesContent: string | null;
  onTemperatureChange: (_event: Event, newValue: number | number[]) => void;
}

const CoachingConfiguration = ({
  attributeStatsContent,
  lensDefinitionContent,
  teamBestPracticesContent,
  onTemperatureChange
}: CoachingConfigurationProps) => {
  const {
    customPrompt,
    systemPrompt,
    temperature,
    setCustomPrompt,
    setSystemPrompt
  } = useCoachingGeneratorStore();

  return (
    <Accordion sx={{ mt: 2, boxShadow: "none", "&:before": { display: "none" } }}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        sx={{ px: 0, minHeight: "unset", "& .MuiAccordionSummary-content": { my: 1 } }}
      >
        <Typography variant="body2" color="text.secondary">
          Configuration
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ px: 0, pt: 0 }}>
        <PromptTextField
          label="System Prompt"
          placeholder="Enter system prompt for the AI coach..."
          value={systemPrompt}
          onChange={setSystemPrompt}
        />
        <PromptTextField
          label="User Prompt"
          placeholder="Enter custom prompt for the AI coach..."
          value={customPrompt}
          onChange={setCustomPrompt}
        />
        <ContextOptions
          attributeStatsContent={attributeStatsContent}
          lensDefinitionContent={lensDefinitionContent}
          teamBestPracticesContent={teamBestPracticesContent}
        />
        <TemperatureControl temperature={temperature} onTemperatureChange={onTemperatureChange} />
      </AccordionDetails>
    </Accordion>
  );
};

export default CoachingConfiguration;
